import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles({
  userImage: {
    display: 'inline-block',
    width: '24px',
    height: '24px',
    lineHeight: '24px',
    fontWeight: 'normal',
    margin: '5px -5px',
    border: 'solid 4px #fff',
    borderRadius: '50px',
    fontSize: '8px',
  },
  imagesStack: {
    // minWidth: '50%',
    display: 'inline-block',
  },
  imageCount: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginLeft: '20px',
  },
});
